export function getApiErrorMessage(error, actionLabel = 'perform this action') {
    const status = error?.response?.status;

    if (status === 403) {
        return 'You do not have permission to ' + actionLabel + '.';
    }

    if (status === 500) {
        return 'Server error. Please try again later.';
    }

    return 'Unable to ' + actionLabel + '. Please try again.' + (error?.message ? ' Error: ' + error.message : '');
}
